/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProductCategory,
    ProductCategoryFromJSON,
    ProductCategoryFromJSONTyped,
    ProductCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateProductCategoryRequest
 */
export interface CreateProductCategoryRequest {
    /**
     * 
     * @type {ProductCategory}
     * @memberof CreateProductCategoryRequest
     */
    productCategory: ProductCategory;
}

export function CreateProductCategoryRequestFromJSON(json: any): CreateProductCategoryRequest {
    return CreateProductCategoryRequestFromJSONTyped(json, false);
}

export function CreateProductCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProductCategoryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productCategory': ProductCategoryFromJSON(json['product_category']),
    };
}

export function CreateProductCategoryRequestToJSON(value?: CreateProductCategoryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_category': ProductCategoryToJSON(value.productCategory),
    };
}


